module.exports = __webpack_public_path__ + "static/media/CEDU_white.d90be602.png";